import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const ForgotPasswordPage = () => {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await forgotPassword(email.trim());
    setLoading(false);
    setSent(true);
  };

  return (
    <div className="px-4 md:px-8 py-12 md:py-20 min-h-[70vh]" data-testid="forgot-page">
      <div className="max-w-md mx-auto border-4 border-[#1C1914] bg-[#FFFDF5] shadow-hard p-6 md:p-10">
        <p className="font-condensed text-sm uppercase tracking-widest text-[#D95D39]">// forgotten</p>
        <h1 className="font-display text-4xl md:text-5xl uppercase leading-none mt-2">
          Reset your password.
        </h1>

        {!sent && (
          <>
            <p className="font-body text-base mt-3 text-[#1C1914]/80">
              Enter your email — we'll send you a magic link. (Link self-destructs in 60 minutes.)
            </p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="block font-condensed text-xs uppercase tracking-widest text-[#1C1914]/70 mb-1">Email</label>
                <input
                  type="email"
                  required
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input-duds"
                  data-testid="forgot-email"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="btn-duds w-full flex items-center justify-center gap-2"
                data-testid="forgot-submit"
              >
                {loading && <Loader2 size={16} className="animate-spin" />}
                Send reset link
              </button>
            </form>
          </>
        )}

        {sent && (
          <div data-testid="forgot-sent">
            <p className="font-body text-base mt-4 text-[#1C1914]/85">
              Check your inbox. If <strong>{email}</strong> is registered, a reset link is on its way.
            </p>
            <p className="font-body text-sm mt-3 text-[#1C1914]/60">
              If it doesn't show up in 5 minutes, check spam. If still nothing, try again or get in touch.
            </p>
          </div>
        )}

        <div className="mt-6 font-condensed text-xs uppercase tracking-widest text-center">
          <Link to="/login" className="text-[#1C1914]/70 hover:text-[#D95D39]" data-testid="forgot-back-login">
            ← Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
